module.exports = __webpack_public_path__ + "media/images/fake/008-1c07e28bb5722029bc0808f39c77fae0.jpg";